import { BaseApiService } from "../base/base-api.service";
import { PropsFilter } from "../../models/api/props-filter/props-filter";
import { ListSortDirection } from "../../models/api/sort";
import { UserDTO, UserSTO } from "../../models/user";
import { UserLoginHistoryDTO } from "../../models/user-login-history";
import Request2FaSetupResponseDTO from "../../models/auth/request-2fa-setup-dto";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { UserActivityHistoryDTO } from "../../models/user-activity-history/user-activity-history-dto";
import { UserByEmailDTO } from "../../models/user-by-email/user-by-email-dto";

export class UsersApiService extends BaseApiService<
  UserDTO | UserByEmailDTO | UserActivityHistoryDTO | UserLoginHistoryDTO | Request2FaSetupResponseDTO,
  UserSTO
> {
  constructor() {
    super({
      servicePath: "/Users",
      loadItemsPath: "/GetUsers",
      saveItemsPath: "/SaveUsers",
    });
  }
}

export const loadUsers = async (id: string) => {
  debugger;
  const response = await new UsersApiService().loadItems(
    {
      ids: !id ? [] : [id],
      createdByUsers: [],
      modifiedByUsers: [],
      isDeleted: false,
    } as PropsFilter,
    "",
    [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      },
    ],
    { pageNumber: 0, pageSize: 1000 }
  );

  return response;
};

export const updateCurrentUser = async (user: UserSTO) => {
  const usersApiService = new UsersApiService();
  usersApiService.useSaveItemsPath("/UpdateCurrentUser");
  const response = await usersApiService.saveItems([user]);

  toastifyResponse(response, "all");

  return response;
};
